export default "__VITE_ASSET__DsJ99Wci__ 1920w";